<template>
  <div class="flex flex-row-wrap justify-center mt-20 ml-20 mr-5">
    <div>
      <span class="circle mr-5" :style="circleColor"></span>
    </div>
    <div>
      <dt :title="name" class="hello">{{ symbol }}: {{ name }}</dt>
      <p class="mb-0">Email & IM Count: {{ count }}</p>
      <p class="mt-0 size">Max Points: {{ roundedMaxPoint }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: true,
      },
      // minPoint: {
      //   type: Number,
      //   required: true,
      // },
      maxPoint: {
        type: Number,
        required: true,
      },
      count: {
        type: Number,
        required: true,
      },
      symbol: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        required: false,
      },
    },

    computed: {
      circleColor() {
        return { backgroundColor: this.color };
      },
      roundedMaxPoint() {
        return this.maxPoint.toFixed(0);
      },
      // roundedMinPoint() {
      //   return this.minPoint.toFixed(0);
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .circle {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
    margin-top: 5px;
  }
  .size {
    min-width: 206px;
  }
  .hello {
    width: 170px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
